import React, { ChangeEvent, FunctionComponent } from "react";

import { Caption, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { LOC_BASIC_CONDITION, LOC_COMMENT, LOC_SCRIPT } from "../../../../../../locKeys";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_CALL_SCRIPT_SCRIPT_AT } from "../../../../../../workflowParser/constants";
import { Memo } from "../../../../components";
import { ActionPageProps } from "../types";

export const CallScriptPage: FunctionComponent<ActionPageProps> = ({ properties, updateAction, hostKey }) => {
    const onScriptChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_CALL_SCRIPT_SCRIPT_AT, value: e.target.value }]);
    };

    const onConditionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_CONDITION_AT, value: e.target.value }]);
    };

    const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_COMMENT_AT, value: e.target.value }]);
    };

    return (
        <GridLayout columns={GridColumnCount.one} gap={GridGapSize.two}>
            <GridLayoutItem>
                <Caption required locKey={LOC_SCRIPT} />
                <Memo qa={LOC_SCRIPT} required value={properties[CONST_CALL_SCRIPT_SCRIPT_AT]} onChange={onScriptChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_BASIC_CONDITION} />
                <Memo qa={LOC_BASIC_CONDITION} value={properties[CONST_ACTION_CONDITION_AT]} onChange={onConditionChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_COMMENT} />
                <Memo qa={LOC_COMMENT} value={properties[CONST_ACTION_COMMENT_AT]} onChange={onCommentChange} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
